<template>
    <div class="pricing-area pt-100 pb-70">
      <div class="container">
        <div class="section-title">
          <span class="sub-title">
            <i class="flaticon-hashtag-symbol"></i>
            {{ $t('prices_span') }}
          </span>
          <h2>{{ $t('prices_h2') }}</h2>
        </div>
  
        <div class="accordion">
          <div 
            class="accordion-item"
            v-for="(tab, index) in tabs"
            :key="tab.id"
          >
            <button 
              class="accordion-header-prices"
              @click="toggleAccordion(index)"
              :class="{ active: tab.isOpen }"
            >
              <span style="color: black">{{ tab.name }}</span> 
              <span class="plus-icon-container">
                <i class="bx bx-plus"></i>
              </span>     
            </button>
            <div class="accordion-content" v-if="tab.isOpen">
              <div class="sub-accordion">
                <div 
                  class="accordion-item"
                  v-for="(item, itemIndex) in tab.items"
                  :key="itemIndex"
                >
                  <button 
                    class="accordion-header-prices"
                    @click="toggleSubAccordion(index, itemIndex)"
                    :class="{ active: item.isOpen }"
                  >
                    <span>{{ item.title }}</span>
                    <span class="plus-icon-container">
                      <i class="bx bx-plus"></i>
                    </span>
                  </button>
                  <div class="accordion-content" v-if="item.isOpen">
                    <div 
                      class="single-pricing-table"
                      v-for="(subItem, subIndex) in item.subItems"
                      :key="subIndex"
                    >
                      <div class="pricing-header">
                        <h3>{{ subItem.title }}</h3>
                      </div>
  
                      <div class="price">
                        <span v-if="item.startsFrom">{{ $t('prices_features_from') }} </span>
                        <span :class="{ 'small-text': item.price === $t('prices_upon_consultation') }">
                          {{ item.price === $t('prices_upon_consultation') ? item.price : item.price + '€' }}
                        </span>
  
                        <ul v-if="item.extras" class="extra-info-list">
                          <li v-for="(extra, idx) in item.extras" :key="idx">
                            <i></i> {{ $t(extra) }}
                          </li>
                        </ul>
                      </div>
  
                      <ul 
                        v-if="subItem.pricingFeatures && subItem.pricingFeatures.length"
                        class="pricing-features"
                      >
                        <h5>{{ $t('prices_features_general_included') }}</h5>
  
                        <li
                          v-for="feature in subItem.pricingFeatures"
                          :key="feature.id"
                          :class="feature.class"
                        >
                          • {{ $t(feature.feature) }}
                        </li>
                      </ul>
  
                      <div class="pricing-btn">
                        <router-link :to="subItem.btnLink" class="default-btn">
                          Buy Now
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PricingSmallScreenLayout',
    data () {
      return {
        tabs: [
                {
                    id: 1,
                    name: 'All on 4',
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: '8000',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allfour_standard_upper' },
                                        { id: 2, feature: 'prices_allfour_standard_lower' },
                                        { id: 3, feature: 'prices_allfour_standard_toothshades' },
                                        { id: 4, feature: 'prices_allfour_standard_materials' },
                                        { id: 5, feature: 'prices_allfour_standard_implants' },
                                        { id: 6, feature: 'prices_allfour_standard_prosthetics' },
                                        { id: 7, feature: 'prices_allfour_standard_fixed' },
                                        { id: 8, feature: 'prices_allfour_standard_individual' },
                                        { id: 9, feature: 'prices_allfour_standard_warranty' }
                                    ]
                                },
                            ],
                            extras: [
                                'nobel_implant_extra',
                                'upper_lower_jaws_four_standard'
                            ],
                        },
                        {
                            title: this.$t('prices_packages_premium'),
                            price: '10500',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_packages_premium'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allfour_premium_upper' },
                                        { id: 2, feature: 'prices_allfour_premium_lower' },
                                        { id: 3, feature: 'prices_allfour_premium_toothshades' },
                                        { id: 4, feature: 'prices_allfour_premium_materials' },
                                        { id: 5, feature: 'prices_allfour_premium_implants' },
                                        { id: 6, feature: 'prices_allfour_premium_prosthetics' },
                                        { id: 7, feature: 'prices_allfour_premium_fixed' },
                                        { id: 8, feature: 'prices_allfour_premium_individual' },
                                        { id: 9, feature: 'prices_allfour_premium_warranty' }
                                    ],
                                    extras: [
                                        'nobel_implant_extra',
                                        'upper_lower_jaws_four_premium'
                                    ],
                                },
                            ]
                        },
                        {
                            title: this.$t('prices_packages_gold'),
                            price: '11000',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_gold'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allfour_gold_upper' },
                                        { id: 2, feature: 'prices_allfour_gold_lower' },
                                        { id: 3, feature: 'prices_allfour_gold_toothshades' },
                                        { id: 4, feature: 'prices_allfour_gold_materials' },
                                        { id: 5, feature: 'prices_allfour_gold_implants' },
                                        { id: 6, feature: 'prices_allfour_gold_prosthetics' },
                                        { id: 7, feature: 'prices_allfour_gold_fixed' },
                                        { id: 8, feature: 'prices_allfour_gold_individual' },
                                        { id: 9, feature: 'prices_allfour_gold_warranty' }
                                    ],
                                    extras: [
                                        'nobel_implant_extra',
                                        'upper_lower_jaws_four_gold'
                                    ],
                                },
                            ]
                        },
                    ]
                },
                {
                    id: 2,
                    name: 'All on 6',
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: '8500',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allsix_standard_upper' },
                                        { id: 2, feature: 'prices_allsix_standard_lower' },
                                        { id: 3, feature: 'prices_allsix_standard_toothshades' },
                                        { id: 4, feature: 'prices_allsix_standard_materials' },
                                        { id: 5, feature: 'prices_allsix_standard_implants' },
                                        { id: 6, feature: 'prices_allsix_standard_prosthetics' },
                                        { id: 7, feature: 'prices_allsix_standard_fixed' },
                                        { id: 8, feature: 'prices_allsix_standard_individual' },
                                        { id: 9, feature: 'prices_allsix_standard_warranty' }
                                    ],
                                    extras: [
                                        'nobel_implant_extra',
                                        'upper_lower_jaws_six_standard'
                                    ],
                                },
                                 
                            ]
                        },
                        {
                           title: this.$t('prices_packages_premium'),
                            price: '11000',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_packages_premium'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allsix_premium_upper' },
                                        { id: 2, feature: 'prices_allsix_premium_lower' },
                                        { id: 3, feature: 'prices_allsix_premium_toothshades' },
                                        { id: 4, feature: 'prices_allsix_premium_materials' },
                                        { id: 5, feature: 'prices_allsix_premium_implants' },
                                        { id: 6, feature: 'prices_allsix_premium_prosthetics' },
                                        { id: 7, feature: 'prices_allsix_premium_fixed' },
                                        { id: 8, feature: 'prices_allsix_premium_individual' },
                                        { id: 9, feature: 'prices_allsix_premium_warranty' }
                                    ],
                                    extras: [
                                        'nobel_implant_extra',
                                        'upper_lower_jaws_six_premium'
                                    ],
                                },
                                 
                            ]
                        },
                        {
                            title: this.$t('prices_packages_gold'),
                            price: '11500',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_gold'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_allsix_gold_upper' },
                                        { id: 2, feature: 'prices_allsix_gold_lower' },
                                        { id: 3, feature: 'prices_allsix_gold_toothshades' },
                                        { id: 4, feature: 'prices_allsix_gold_materials' },
                                        { id: 5, feature: 'prices_allsix_gold_implants' },
                                        { id: 6, feature: 'prices_allsix_gold_prosthetics' },
                                        { id: 7, feature: 'prices_allsix_gold_fixed' },
                                        { id: 8, feature: 'prices_allsix_gold_individual' },
                                        { id: 9, feature: 'prices_allsix_gold_warranty' }
                                    ],
                                    extras: [
                                        'nobel_implant_extra',
                                        'upper_lower_jaws_six_gold'
                                    ],
                                },
                                 
                            ]
                        },
                         
                    ]
                },
                {
                    id: 3,
                    name: this.$t('prices_implants'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_features_from') +'1200',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_dental_implant_label' },
                                        { id: 2, feature: 'prices_dental_implant_crown' },
                                        { id: 3, feature: 'prices_dental_implant_bone_craft' },
                                        { id: 4, feature: 'prices_dental_implant_warranty' },
                                        { id: 5, feature: 'prices_common_implants_one' },
                                        { id: 6, feature: 'prices_common_one' },
                                        { id: 7, feature: 'prices_common_two' },
                                        { id: 8, feature: 'prices_common_three' },
                                        { id: 9, feature: 'prices_common_five' },
                                    ]
                                }
                            ]
                        },
                        {
                            title: this.$t('prices_packages_premium'),
                            price: this.$t('prices_features_from') +'1400',
                            btnLink: '/contact-us',
                            isOpen:false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_premium'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_dental_implant_premium_label' },
                                        { id: 2, feature: 'prices_dental_implant_crown' },
                                        { id: 3, feature: 'prices_dental_implant_bone_craft' },
                                        { id: 4, feature: 'prices_dental_implant_warranty' },
                                        { id: 5, feature: 'prices_common_implants_one' },
                                        { id: 6, feature: 'prices_common_one' },
                                        { id: 7, feature: 'prices_common_two' },
                                        { id: 8, feature: 'prices_common_three' },
                                        { id: 9, feature: 'prices_common_five' },
                                    ]
                                }
                            ]
                        },
                        {
                            title: this.$t('prices_packages_gold'),
                            price: this.$t('prices_features_from') +'1600',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_gold'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: 'prices_dental_implant_gold_label' },
                                        { id: 2, feature: 'prices_dental_implant_crown' },
                                        { id: 3, feature: 'prices_dental_implant_bone_craft' },
                                        { id: 4, feature: 'prices_dental_implant_warranty' },
                                        { id: 5, feature: 'prices_common_implants_one' },
                                        { id: 6, feature: 'prices_common_one' },
                                        { id: 7, feature: 'prices_common_two' },
                                        { id: 8, feature: 'prices_common_three' },
                                        { id: 9, feature: 'prices_common_five' },
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 4,
                    name: this.$t('prices_rehab'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                    ]
                },
                {
                    id: 5,
                    name: this.$t('prices_veneers'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_veneers_composite'),
                            price: '250',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_veneers_composite'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees') , class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },

                                    ]
                                },
                            ]
                        },
                        {
                           title: this.$t('prices_veneers_emax'),
                            price: '600',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_veneers_emax'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees') , class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },
                                    ]
                                },
                            ]
                        }
                        
                    ]
                },
                {
                    id: 6,
                    name: this.$t('prices_zcrowns'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_zcrowns'),
                            price: '350',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: true,
                            subItems: [
                                {
                                    title: this.$t('prices_zcrowns'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees') , class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },
                                    ]
                                },
                                 
                            ]
                        },
                         
                    ]
                },
                {
                    id: 7,
                    name: this.$t('prices_whitening'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_whitening'),
                            price: '250',
                            btnLink: '/contact-us',
                            isOpen: true,
                            subItems: [
                                {
                                    title: this.$t('prices_whitening'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_visit_times_one'), class: '' },
  ]
                                },
                                 
                            ]
                        },
                        
                    ]
                },
                {
                    id: 8,
                    name: this.$t('prices_hsmile'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                         
                    ]
                },
                {
                    id: 9,
                    name: this.$t('prices_invisible_orth'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: '59',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: '1 or more impplants (LABEL)', class: '' },
                                        { id: 2, feature: '12 Temporary Teeth (Fixed Denture)', class: '' },
                                        { id: 3, feature: '12 Permanent Teeth', class: '' },
                                        { id: 4, feature: '3D Dental tomography &Panoramic X-Ray', class: '' },
                                        { id: 5, feature: 'Anesthetics', class: '' },
                                        { id: 6, feature: 'Anti-biotics, Pain killers, mouth wash etc.', class: '' },
                                        { id: 7, feature: 'Laboratory Fees', class: '' },
                                        { id: 8, feature: 'The Dentist’s Time & Work', class: '' },
                                        { id: 9, feature: 'Requires 2 visits, each visit takes 6-7 days within 3 to 6 months’ time scale.', class: '' }//class: 'color-gray',
                                    ]
                                },
                                 
                            ]
                        }
                         
                    ]
                },
                {
                    id: 10,
                    name: this.$t('prices_zbridges'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: '59',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: '1 or more impplants (LABEL)', class: '' },
                                        { id: 2, feature: '12 Temporary Teeth (Fixed Denture)', class: '' },
                                        { id: 3, feature: '12 Permanent Teeth', class: '' },
                                        { id: 4, feature: '3D Dental tomography &Panoramic X-Ray', class: '' },
                                        { id: 5, feature: 'Anesthetics', class: '' },
                                        { id: 6, feature: 'Anti-biotics, Pain killers, mouth wash etc.', class: '' },
                                        { id: 7, feature: 'Laboratory Fees', class: '' },
                                        { id: 8, feature: 'The Dentist’s Time & Work', class: '' },
                                        { id: 9, feature: 'Requires 2 visits, each visit takes 6-7 days within 3 to 6 months’ time scale.', class: '' }//class: 'color-gray',
                                    ]
                                },
                                 
                            ]
                        },
                        {
                           title: this.$t('prices_packages_premium'),
                            price: '59',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_packages_premium'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: '1 or more impplants (LABEL)', class: '' },
                                        { id: 2, feature: '12 Temporary Teeth (Fixed Denture)', class: '' },
                                        { id: 3, feature: '12 Permanent Teeth', class: '' },
                                        { id: 4, feature: '3D Dental tomography &Panoramic X-Ray', class: '' },
                                        { id: 5, feature: 'Anesthetics', class: '' },
                                        { id: 6, feature: 'Anti-biotics, Pain killers, mouth wash etc.', class: '' },
                                        { id: 7, feature: 'Laboratory Fees', class: '' },
                                        { id: 8, feature: 'The Dentist’s Time & Work', class: '' },
                                        { id: 9, feature: 'Requires 2 visits, each visit takes 6-7 days within 3 to 6 months’ time scale.', class: '' }//class: 'color-gray',
                                    ]
                                },
                                 
                            ]
                        },
                        {
                            title: this.$t('prices_packages_gold'),
                            price: '59',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_gold'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: '1 or more impplants (LABEL)', class: '' },
                                        { id: 2, feature: '12 Temporary Teeth (Fixed Denture)', class: '' },
                                        { id: 3, feature: '12 Permanent Teeth', class: '' },
                                        { id: 4, feature: '3D Dental tomography &Panoramic X-Ray', class: '' },
                                        { id: 5, feature: 'Anesthetics', class: '' },
                                        { id: 6, feature: 'Anti-biotics, Pain killers, mouth wash etc.', class: '' },
                                        { id: 7, feature: 'Laboratory Fees', class: '' },
                                        { id: 8, feature: 'The Dentist’s Time & Work', class: '' },
                                        { id: 9, feature: 'Requires 2 visits, each visit takes 6-7 days within 3 to 6 months’ time scale.', class: '' }//class: 'color-gray',
                                    ]
                                },
                                 
                            ]
                        },
                         
                    ]
                },
                {
                    id: 11,
                    name: this.$t('prices_denture'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_denture'),
                            price: '800',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: true,
                            subItems: [
                                {
                                    title: this.$t('prices_denture'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees'), class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },

                                    ]
                                },
                                 
                            ]
                        },
                         
                    ]
                },
                {
                    id: 12,
                    name: this.$t('prices_inonlay'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_inonlay_composite'),
                            price: '250',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_inonlay_composite'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees'), class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },

                                    ]
                                },
                                 
                            ]
                        },
                        {
                           title: this.$t('prices_inonlay_porcelain'),
                            price: '350',
                            startsFrom: true,
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_inonlay_porcelain'),
                                    btnLink: '/contact-us',
                                    pricingFeatures: [
                                        { id: 1, feature: this.$t('prices_features_general_time'), class: '' },
                                        { id: 2, feature: this.$t('prices_features_general_lab_fees'), class: '' },
                                        { id: 3, feature: this.$t('prices_features_general_visit_times_one'), class: '' },
                                    ]
                                },
                                 
                            ]
                        },
                         
                    ]
                },
                {
                    id: 13,
                    name: this.$t('prices_ftreatment'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                         
                    ]
                },
                {
                    id: 14,
                    name: this.$t('prices_botoxetc'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                         
                    ]
                },
                {
                    id: 15,
                    name: this.$t('prices_prp'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                    ]
                },
                {
                    id: 16,
                    name: this.$t('prices_alternative_care'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                         
                    ]
                },
                {
                    id: 17,
                    name: this.$t('prices_periodontology'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_periodontology_conservative_therapy_title'),
                            price: '500',
                            btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                    title: this.$t('prices_periodontology_conservative_therapy_title'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        },
                        {
                           title: this.$t('prices_periodontology_surgical_therapy_title'),
                           price: this.$t('prices_upon_consultation'),
                           btnLink: '/contact-us',
                            isOpen: false,
                            subItems: [
                                {
                                   title: this.$t('prices_periodontology_surgical_therapy_title'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        },
                        
                         
                    ]
                },
                {
                    id: 18,
                    name: this.$t('prices_orofacial_pain'),
                    isOpen: false,
                    items: [
                        {
                            title: this.$t('prices_packages_standard'),
                            price: this.$t('prices_upon_consultation'),
                            btnLink: '/contact-us',
                            isOpen: true,
                            subItems: [
                                {
                                    title: this.$t('prices_packages_standard'),
                                     
                                    btnLink: '/contact-us',
                                    pricingFeatures: []
                                },
                                 
                            ]
                        }
                         
                    ]
                }

            ]
      };
    },
    methods: {
      toggleAccordion(index) {
        this.tabs.forEach((tab, tabIndex) => {
          tab.isOpen = index === tabIndex ? !tab.isOpen : false;
        });
      },
      toggleSubAccordion(tabIndex, itemIndex) {
        this.tabs[tabIndex].items.forEach((item, index) => {
          item.isOpen = itemIndex === index ? !item.isOpen : false;
        });
      }
    }
  };
  </script>
  
 
  